module.exports = __webpack_public_path__ + "01_short_brown.08fb68eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_short_brown.png
// module id = PRSD
// module chunks = 0